import { useState, useCallback } from 'react';
import html2canvas from 'html2canvas';

export const useLogoGenerator = () => {
  const [isExporting, setIsExporting] = useState(false);

  const handleExport = useCallback(async (format: 'png' | 'svg' = 'png') => {
    const element = document.getElementById('logo-preview');
    if (!element) return;

    setIsExporting(true);
    try {
      if (format === 'svg') {
        // Get the SVG element
        const svgElement = element.querySelector('svg');
        if (!svgElement) throw new Error('SVG element not found');

        // Create SVG string
        const svgData = new XMLSerializer().serializeToString(svgElement);
        const svgBlob = new Blob([svgData], { type: 'image/svg+xml;charset=utf-8' });
        const url = URL.createObjectURL(svgBlob);

        // Download SVG
        const link = document.createElement('a');
        link.download = 'scalenix-logo.svg';
        link.href = url;
        link.click();
        URL.revokeObjectURL(url);
      } else {
        // PNG export using html2canvas
        const canvas = await html2canvas(element);
        const link = document.createElement('a');
        link.download = 'scalenix-logo.png';
        link.href = canvas.toDataURL('image/png');
        link.click();
      }
    } catch (error) {
      console.error('Failed to export logo:', error);
    } finally {
      setIsExporting(false);
    }
  }, []);

  return {
    handleExport,
    isExporting
  };
};